import { contactHistoryNotes, nomination as nominationForm, sellerRequestDocument } from 'forms';

import { REDUCER_NAME as USER_REDUCER_NAME } from '@gef-ui/cdu-user/constants';
import userReducer from '@gef-ui/cdu-user/reducer';
import codelistReducer from '@gef-ui/codelist/reducer/codelistReducer';
import { REDUCER_NAME as DELEGATION_REDUCER_NAME } from '@gef-ui/delegations/constants';
import delegationsReducer from '@gef-ui/delegations/reducer';
import { REDUCER_NAME as IAS_REDUCER_NAME } from '@gef-ui/features/iasc/constants';
import iascReducer from '@gef-ui/features/iasc/reducer';
import subheaderReducer from '@gef-ui/features/subheader/reducers/defaultReducer';
import { REDUCER_NAME as CACHE_REDUCER_NAME } from '@gef-ui/middleware-api/redux/cache/constants';
import cacheReducer from '@gef-ui/middleware-api/redux/cache/reducers';
import { REDUCER_NAME as STATUS_REDUCER_NAME } from '@gef-ui/middleware-api/redux/status/constants';
import statusReducer from '@gef-ui/middleware-api/redux/status/reducers';
import appContextReducer from '@gef-ui/redux-common/reducers/appContext';
import temporaryStoreReducer from '@gef-ui/redux-common/reducers/temporaryStore';
import { REDUCER_NAME as APM_REDUCER_NAME } from '@gef-ui/statemanagement-redux/apm/constants';
import apmReducer from '@gef-ui/statemanagement-redux/apm/reducer';
import toastrReducer from '@gef-ui/toastr/reducers/toastrReducer';

import { LOADER_REDUCER_NAME, URL_REDUCER_NAME } from 'app/configurator/constants';
import loaderReducer from 'app/configurator/reducer/loader';
import urlsReducer from 'app/configurator/reducer/urls';
import app from 'features/common/app';
import collapsibleTable from 'features/common/collapsibleTable';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import subheaderCollapsibleReducer, {
	REDUCER_NAME as subheaderCollapsibleReducerName,
} from 'features/common/Subheader/slice';
import submitFormDialogReducer, {
	REDUCER_NAME as submitFormDialogReducerName,
} from 'features/common/submitFormDialog/slice';
import { NAME as agenciesReducerName } from 'features/other/organizationStructureMUI/agency/constants';
import agenciesReducer from 'features/other/organizationStructureMUI/agency/reducer';
import { NAME as channelsReducerName } from 'features/other/organizationStructureMUI/channel/constants';
import channelsReducer from 'features/other/organizationStructureMUI/channel/reducer';
import { NAME as managersReducerName } from 'features/other/organizationStructureMUI/managers/constants';
import managersReducer from 'features/other/organizationStructureMUI/managers/reducer';
import { NAME as ppzReducerName } from 'features/other/organizationStructureMUI/ppz/constants';
import ppzReducer from 'features/other/organizationStructureMUI/ppz/reducer';
import { NAME as regionsReducerName } from 'features/other/organizationStructureMUI/regions/constants';
import regionsReducer from 'features/other/organizationStructureMUI/regions/reducer';
import { NAME as sellersReducerName } from 'features/other/organizationStructureMUI/seller/constants';
import sellersReducer from 'features/other/organizationStructureMUI/seller/reducer';
import resolverSettingsReducer, {
	REDUCER_NAME as resolverSettingsReducerName,
} from 'features/other/resolverSettings/slice';
import typeTasks from 'features/other/typeTasks';
import bruttoProduction from 'features/views/bruttoProduction';
import { NAME as dashboardsCampaignDetailReducerName } from 'features/views/campaignDashboards/campaignDetail/constants';
import dashboardsCampaignDetailReducer from 'features/views/campaignDashboards/campaignDetail/reducer';
import campaignManagers from 'features/views/campaignDashboards/campaignManagers';
import campaignPpzts from 'features/views/campaignDashboards/campaignPpzts';
import campaignRegions from 'features/views/campaignDashboards/campaignRegions';
import campaigns from 'features/views/campaignDashboards/campaigns';
import campaignSellers from 'features/views/campaignDashboards/campaignSellers';
import orderReducer, { REDUCER_NAME as orderReducerName } from 'features/views/campaignDashboards/order/slice';
import dashboardsSidebar from 'features/views/campaignDashboards/sidebar';
import dashboardStructure from 'features/views/campaignDashboards/structure';
import campaignsListFilter from 'features/views/campaignList';
import campaignManagementCampaignDetail from 'features/views/campaignManagement/campaignDetail';
import campaignManagementContactReleasing from 'features/views/campaignManagement/contactReleasing';
import campaignManagementContacts from 'features/views/campaignManagement/contacts';
import campaignManagementContactStates from 'features/views/campaignManagement/contactStates';
import campaignManagementNominatedSellers from 'features/views/campaignManagement/nominatedSellers';
import nominations from 'features/views/campaignNominations';
import campaignRegionNomination from 'features/views/campaignRegionNomination';
import campaignsEntity from 'features/views/campaigns';
import campaignAdditionalData from 'features/views/campaignSettings/additionalData';
import campaignDetail from 'features/views/campaignSettings/campaignDetail';
import guarantors from 'features/views/campaignSettings/guarantors';
import startupCurve from 'features/views/campaignSettings/startupCurve';
import campaignState from 'features/views/campaignSettings/states';
import campaignSettingsTabs from 'features/views/campaignSettings/tabs';
import templates from 'features/views/campaignSettings/templates';
import campaignSubsellerNomination from 'features/views/campaignSubsellerNomination';
import clientSearchReducer, { REDUCER_NAME as clientSearchReducerName } from 'features/views/clientSearch/slice';
import contactDetail from 'features/views/contactDetail';
import contactFeedback from 'features/views/contactFeedback';
import contactHistory from 'features/views/contactHistory';
import contactList from 'features/views/contactList';
import contacts from 'features/views/contacts';
import contactTake from 'features/views/contactTake';
import dashboardCampaignManagementReducer, {
	REDUCER_NAME as dashboardCampaignManagementReducerName,
} from 'features/views/dashboard/campaignManagement/slice';
import dashboardCampaignsReducer, {
	REDUCER_NAME as dashboardCampaignsReducerName,
} from 'features/views/dashboard/campaigns/slice';
import dashboardLeadsOverviewReducer, {
	REDUCER_NAME as dashboardLeadsOverviewReducerName,
} from 'features/views/dashboard/leadsOverview/slice';
import dashboardMarketPlaceReducer, {
	REDUCER_NAME as dashboardMarketPlaceReducerName,
} from 'features/views/dashboard/marketPlace/slice';
import dashboardSemaphoreReducer, {
	REDUCER_NAME as dashboardSemaphoreReducerName,
} from 'features/views/dashboard/semaphore/slice';
import dashboardStatisticsReducer, {
	REDUCER_NAME as dashboardStatisticsReducerName,
} from 'features/views/dashboard/statistics/slice';
import dashboardTasksAndInformationReducer, {
	REDUCER_NAME as dashboardTasksAndInformationReducerName,
} from 'features/views/dashboard/tasksAndInformation/slice';
import dashboardTodaysUrgenciesReducer, {
	REDUCER_NAME as dashboardTodaysUrgenciesReducerName,
} from 'features/views/dashboard/todaysUrgencies/slice';
import errorReport from 'features/views/errorReport';
import guarantorsEdit from 'features/views/guarantorsEdit';
import { NAME as leadDetailReducerName } from 'features/views/leadDetail/constants';
import leadDetailReducer from 'features/views/leadDetail/reducer';
import marketPlace from 'features/views/marketPlace';
// todo - old attachment logic still used in some old non MUI components that arent refactored yet - feedbackConfirm, FileUpload etc.
// todo - delete after refactor
import sellerRequestAttachments from 'features/views/newTaskSellerRequest/attachments';
import policyOverview from 'features/views/policyOverview';
import policySearch from 'features/views/policySearch';
import producedProduction from 'features/views/production/common';
import productionDocuments from 'features/views/production/documents';
import productionControlReportModalReducer, {
	REDUCER_NAME as productionControlReportModalReducerName,
} from 'features/views/productionControl/reportProductionControl/slice';
import productionControlReducer, {
	REDUCER_NAME as productionControlReducerName,
} from 'features/views/productionControl/slice';
import productionControlDetailReducer, {
	REDUCER_NAME as productionControlDetailReducerName,
} from 'features/views/productionControlDetail/slice';
import productionNew from 'features/views/productionNew';
import productionReported from 'features/views/productionReport';
import roboAdvisory from 'features/views/roboAdvisory';
import semaphore from 'features/views/semaphore';
import { NAME as settingsReducerName } from 'features/views/settings/constants';
import marketPlaceAgenciesReducer, {
	REDUCER_NAME as marketPlaceAgenciesReducerName,
} from 'features/views/settings/marketPlaceAgencies/slice';
import settingsReducer from 'features/views/settings/reducer';
import { NAME as subsellerSearchReducerName } from 'features/views/subsellerSearch/constants';
import subsellerSearchReducer from 'features/views/subsellerSearch/reducer';
import taskCreatingPagesReducer, {
	REDUCER_NAME as taskCreatingPagesReducerName,
} from 'features/views/taskCreatingPages/slice';
import taskDetail from 'features/views/taskDetail';
import taskFeedback from 'features/views/taskFeedback';
import taskForwarding from 'features/views/taskForwarding';
import taskOverview from 'features/views/taskOverview';
import taskOverviewUserContext from 'features/views/taskOverview/taskOverviewUserContext';
import taskPartnerSearch from 'features/views/taskPartnerSearch';
import taskSearch from 'features/views/taskSearch';
import taskStatistics from 'features/views/taskStatistics';
import unlockedClients from 'features/views/unlockedClients';
import user from 'features/views/user';
import userContext from 'features/views/userContext';
import userSearch from 'features/views/userSearch';
import usersSubordinate from 'features/views/usersSubordinate';
import { resetOnAcion } from 'utils';
import { resetFetchReducerOnAction } from 'utils/redux';

const withFetchReset = resetFetchReducerOnAction(app.types.RESET_REDUCERS);
const withReset = resetOnAcion(app.types.RESET_REDUCERS);

const reducersMap = {
	[CACHE_REDUCER_NAME]: cacheReducer,
	[STATUS_REDUCER_NAME]: statusReducer,
	[app.constants.NAME]: app.reducer,
	appContext: appContextReducer,
	[APM_REDUCER_NAME]: apmReducer,
	[IAS_REDUCER_NAME]: iascReducer,
	[fetch.constants.NAME]: withFetchReset(fetch.reducer),
	[USER_REDUCER_NAME]: userReducer,
	[DELEGATION_REDUCER_NAME]: delegationsReducer,
	[URL_REDUCER_NAME]: urlsReducer,
	[LOADER_REDUCER_NAME]: loaderReducer,
	lastAction: (state, action) => action,
	[user.constants.NAME]: user.reducer,
	toastr: toastrReducer,
	[errorReport.constants.NAME]: errorReport.reducer,
	codelists: codelistReducer,
	subheader: withReset(subheaderReducer),
	temporaryStore: withReset(temporaryStoreReducer),
	[dialog.constants.NAME]: withReset(dialog.reducer),
	[userContext.constants.NAME]: withReset(userContext.reducer),
	[collapsibleTable.constants.NAME]: withReset(collapsibleTable.reducer),
	[campaignsEntity.constants.NAME]: campaignsEntity.reducer,
	[sellerRequestDocument.constants.NAME]: withReset(sellerRequestDocument.reducer),
	[nominationForm.constants.NAME]: withReset(nominationForm.reducer),
	[contactHistoryNotes.constants.NAME]: withReset(contactHistoryNotes.reducer),
	[dashboardsSidebar.constants.NAME]: withReset(dashboardsSidebar.reducer),
	[dashboardStructure.constants.NAME]: withReset(dashboardStructure.reducer),
	[dashboardsCampaignDetailReducerName]: withReset(dashboardsCampaignDetailReducer),
	[campaigns.constants.NAME]: withReset(campaigns.reducer),
	[campaignSettingsTabs.constants.NAME]: withReset(campaignSettingsTabs.reducer),
	[campaignRegions.constants.NAME]: withReset(campaignRegions.reducer),
	[campaignManagers.constants.NAME]: withReset(campaignManagers.reducer),
	[campaignSellers.constants.NAME]: withReset(campaignSellers.reducer),
	[campaignPpzts.constants.NAME]: withReset(campaignPpzts.reducer),
	[campaignManagementCampaignDetail.constants.NAME]: withReset(campaignManagementCampaignDetail.reducer),
	[campaignManagementContactReleasing.constants.NAME]: withReset(campaignManagementContactReleasing.reducer),
	[campaignManagementContacts.constants.NAME]: withReset(campaignManagementContacts.reducer),
	[campaignManagementContactStates.constants.NAME]: withReset(campaignManagementContactStates.reducer),
	[campaignManagementNominatedSellers.constants.NAME]: withReset(campaignManagementNominatedSellers.reducer),
	[campaignRegionNomination.constants.NAME]: withReset(campaignRegionNomination.reducer),
	[campaignSubsellerNomination.constants.NAME]: withReset(campaignSubsellerNomination.reducer),
	[campaignsListFilter.constants.NAME]: withReset(campaignsListFilter.reducer),
	[campaignState.constants.NAME]: withReset(campaignState.reducer),
	[clientSearchReducerName]: withReset(clientSearchReducer),
	[taskForwarding.constants.NAME]: withReset(taskForwarding.reducer),
	[taskOverview.constants.NAME]: withReset(taskOverview.reducer),
	[taskOverviewUserContext.constants.NAME]: taskOverviewUserContext.reducer,
	[typeTasks.constants.NAME]: withReset(typeTasks.reducer),
	[taskSearch.constants.NAME]: withReset(taskSearch.reducer),
	[taskPartnerSearch.constants.NAME]: withReset(taskPartnerSearch.reducer),
	[taskDetail.constants.NAME]: withReset(taskDetail.reducer),
	[contactList.constants.NAME]: withReset(contactList.reducer),
	[contactTake.constants.NAME]: withReset(contactTake.reducer),
	[taskFeedback.constants.NAME]: withReset(taskFeedback.reducer),
	[channelsReducerName]: channelsReducer,
	[regionsReducerName]: regionsReducer,
	[agenciesReducerName]: agenciesReducer,
	[managersReducerName]: managersReducer,
	[sellersReducerName]: sellersReducer,
	[ppzReducerName]: ppzReducer,
	[policyOverview.constants.NAME]: withReset(policyOverview.reducer),
	[taskStatistics.constants.NAME]: withReset(taskStatistics.reducer),
	[sellerRequestAttachments.constants.NAME]: withReset(sellerRequestAttachments.reducer),
	[guarantors.constants.NAME]: withReset(guarantors.reducer),
	[guarantorsEdit.constants.NAME]: withReset(guarantorsEdit.reducer),
	[usersSubordinate.constants.NAME]: withReset(usersSubordinate.reducer),
	[startupCurve.constants.NAME]: withReset(startupCurve.reducer),
	[campaignDetail.constants.NAME]: withReset(campaignDetail.reducer),
	[campaignState.constants.NAME]: withReset(campaignState.reducer),
	[contacts.constants.NAME]: withReset(contacts.reducer),
	[contactDetail.constants.NAME]: withReset(contactDetail.reducer),
	[contactFeedback.constants.NAME]: withReset(contactFeedback.reducer),
	[contactHistory.constants.NAME]: withReset(contactHistory.reducer),
	[campaignAdditionalData.constants.NAME]: withReset(campaignAdditionalData.reducer),
	[policySearch.constants.NAME]: withReset(policySearch.reducer),
	[userSearch.constants.NAME]: withReset(userSearch.reducer),
	[producedProduction.constants.NAME]: withReset(producedProduction.reducer),
	[productionReported.constants.NAME]: withReset(productionReported.reducer),
	[productionNew.constants.NAME]: withReset(productionNew.reducer),
	[productionDocuments.constants.NAME]: withReset(productionDocuments.reducer),
	[nominations.constants.NAME]: nominations.reducer,
	[orderReducerName]: orderReducer,
	[templates.constants.NAME]: withReset(templates.reducer),
	[unlockedClients.constants.NAME]: withReset(unlockedClients.reducer),
	[bruttoProduction.constants.NAME]: withReset(bruttoProduction.reducer),
	[marketPlace.constants.NAME]: withReset(marketPlace.reducer),
	[leadDetailReducerName]: withReset(leadDetailReducer),
	[roboAdvisory.constants.NAME]: withReset(roboAdvisory.reducer),
	[semaphore.constants.NAME]: withReset(semaphore.reducer),
	[settingsReducerName]: withReset(settingsReducer),
	[subsellerSearchReducerName]: withReset(subsellerSearchReducer),
	[productionControlReducerName]: withReset(productionControlReducer),
	[productionControlDetailReducerName]: withReset(productionControlDetailReducer),
	[productionControlReportModalReducerName]: withReset(productionControlReportModalReducer),
	[taskCreatingPagesReducerName]: withReset(taskCreatingPagesReducer),
	[submitFormDialogReducerName]: withReset(submitFormDialogReducer),
	[subheaderCollapsibleReducerName]: withReset(subheaderCollapsibleReducer),
	[dashboardTodaysUrgenciesReducerName]: withReset(dashboardTodaysUrgenciesReducer),
	[dashboardMarketPlaceReducerName]: withReset(dashboardMarketPlaceReducer),
	[dashboardSemaphoreReducerName]: withReset(dashboardSemaphoreReducer),
	[dashboardCampaignsReducerName]: withReset(dashboardCampaignsReducer),
	[dashboardTasksAndInformationReducerName]: withReset(dashboardTasksAndInformationReducer),
	[dashboardLeadsOverviewReducerName]: withReset(dashboardLeadsOverviewReducer),
	[dashboardStatisticsReducerName]: withReset(dashboardStatisticsReducer),
	[dashboardCampaignManagementReducerName]: withReset(dashboardCampaignManagementReducer),
	[resolverSettingsReducerName]: withReset(resolverSettingsReducer),
	[marketPlaceAgenciesReducerName]: withReset(marketPlaceAgenciesReducer),
};

export default reducersMap;
